<template>
  <v-tooltip top color="primary">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" small color="success" outline>
        <v-avatar>
          <v-icon>check_circle</v-icon>
        </v-avatar>
        {{ $t(`${eventPrefix}.purchased.title`) }}
      </v-chip>
    </template>
    <span class="background--text text--darken-3 body-1">{{
      $t(`${eventPrefix}.purchased.tooltip`)
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "PurchasedIndicator",
  props: {
    eventPrefix: {
      type: String,
      default: 'screener'
    }
  }
};
</script>

<style>
</style>
